/* eslint-disable */
<template>
  <v-container fluid fill-height>
    <v-toolbar :color="expertColor" dark app fixed flat>
      <v-toolbar-title style="width: 300px;" class="ml-5 pl-3">
        <a :href="`${webUrl}`" target="_blank">
          <img src="@/assets/logo.png" style="width: 100px; height: 70px;" alt />
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout align-center justify-center>
      <v-flex xs12 sm12 md7 lg6>
        <v-card class="elevation-12">
          <v-toolbar dark :color="toolbarColor">
            <v-toolbar-title class="display-small" v-if="accountType == 'Expert'">Login ( {{accountType}} (Service Provider) Account )</v-toolbar-title>
            <v-toolbar-title class="display-small" v-if="accountType == 'Sonko'">Login ( {{accountType}} (Employer) Account ) | <v-btn color="red" flat :to="`/login/vip_sonko/normal`">VIP {{accountType}} Account</v-btn></v-toolbar-title>
            <v-toolbar-title class="display-small" v-if="accountType == 'VIP Sonko'">Login ( {{accountType}}/Employer Account ) <!-- | <v-btn color="red" class="pl-0" flat @click="showPaidModal()">Paid Plans with Dedicated Support</v-btn> --></v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap class="placeholder-div">
              <v-flex xs12 sm12>
                <center><v-btn color="red" flat @click="showPaidModal()">Benefits of the Paid VIP Plans</v-btn></center>
              </v-flex>
              <v-flex xs12 sm12>
                <v-text-field
                  prepend-icon="person"
                  v-validate="'required'"
                  :error-messages="errors.collect('phone')"
                  data-vv-name="phone"
                  v-model="phone"
                  label="Phone No. (eg +254712345678 with Country Code)"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12>
                <v-text-field
                  prepend-icon="lock"
                  v-validate="'required'"
                  :error-messages="errors.collect('password')"
                  data-vv-name="password"
                  v-model="password"
                  label="Password"
                  type="password"
                  class="login-label"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12>
                <span style="color:red">{{err_msg}}</span>
              </v-flex>
              <v-flex xs12 sm6 class="pass-reset">
                <v-btn color="primary" flat :to="`/password/reset/${userAccount}`">Forgot Password</v-btn>
              </v-flex>
              <v-flex xs12 sm6>
                <v-spacer></v-spacer>
                <v-btn @click="login" :color="toolbarColor" class="right" dark>Login</v-btn>
              </v-flex>
              <v-flex xs12 sm12>
                <hr />
              </v-flex>
              <v-flex xs12 sm12 class="text-xs-center pt-3">
                New Member?
                <v-btn color="primary" flat :to="`/register/${userAccount}`">Register Now</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>

          <!-- Paid plan popup -->
          <v-dialog v-model="paidPlanDialog" max-width="750px">
            <v-toolbar flat dense color="primary" dark>
              <v-toolbar-title class="title">Benefits of the Paid VIP Plans</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="mx-0" @click.native="paidPlanDialog = false">
                <v-icon color="white">clear</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <ul>
                        <li>Your posted jobs are listed first/top of the list. </li>
                        <li>You can choose additional preferred job locations to alert more experts per job post for fatser bids.</li>
                        <li>You get flexible dedicated support timelines with jobs posting & the bidding process.</li>
                        <li>You get recommendations of reliable experts among other benefits.</li>
                      </ul>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- End -->

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { webUrl } from "@/common/index";
import { mapGetters } from "vuex";
export default {
  name: "FundiLoginPage",
  components: {},
  computed: {
    ...mapGetters(["webUrl"])
  },
  data() {
    return {
      expertColor: "white",
      toolbarColor: null,
      userAccount: null,
      accountType: null,
      loginType: null,
      phone: null,
      password: null,
      err_msg: null,
      loading: false,
      paidPlanDialog: false,
      metaTitle: '',
      metaDescription: ''
    };
  },
  metaInfo() {
    return {
      title: 'Login to your VIP Employer Account',
      meta: [
        { vmid: 'description', name: 'description', content: 'Maximize the benefits of a VIP Sonko/Employer account from job featuring to vast reach to potential experts. This speeds up the process of getting'}
      ]
    }
  },
  watch: {
    "$route.params.type": {
      handler: "setType",
      immediate: true
    }
  },
  methods: {
    showPaidModal() {
      this.paidPlanDialog = true;
    },
    navigateHome() {
      window.location = this.webUrl;
    },
    setType() {
      this.loginType = this.$route.params.type;
    },
    login() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          if (this.phone.startsWith("07") || !this.phone.startsWith("+")) {
            this.err_msg = "Phone no. should start with country code +..";
          } else {
            const data = {
              username: this.phone,
              password: this.password
            };

            const self = this;
            const res = this.$store
              .dispatch("post", { url: `/user/vipsonko/login`, data })
              .then(res => {
                const user = res.user;
                if (res.state == true) {
                  localStorage.setItem("token", res.token);
                  self.$store.commit("setUser", res.user);
                  // check otp
                  if (user.expired == true) {
                    this.$router.push("/vip_sonko/expiry");
                  }
                  else if (user.verified == false) {
                    this.$router.push(
                      `/verify/${this.userAccount}/${user._id}`
                    );
                  } else {
                    localStorage.setItem("token", res.token);
                    self.$store.commit("setUser", res.user);
                    const accountType = res.user.accountType;
                    if (accountType == "vip_sonko") {
                      if (res.subscription) {
                        localStorage.setItem(
                          "account",
                          res.subscription.packageName
                        );
                        localStorage.setItem(
                          "packageOption",
                          res.subscription.packageOption
                        );
                        localStorage.setItem(
                          "expiryDate",
                          res.subscription.endsAt
                        );
                      }
                      if (res.subscription == null) {
                        localStorage.setItem("subscription", "noSubs");
                      }
                      if (res.subscription != null) {
                        localStorage.setItem("subscription", "subscribed");
                        localStorage.setItem(
                          "locations",
                          res.subscription.locations
                        );
                      }
                      /*const loc = res.user.locationOne;
                      if (loc == undefined) {
                        this.$router.push("/vip_sonko/profile");
                      } else {
                        this.$router.push("/vip_sonko/landing");
                      }*/
                      this.$router.push("/vip_sonko/profile");
                    }
                    // clear data
                    self.loading = false;
                    self.password = null;
                    self.phone = null;
                    res.err_msg = null;
                    // end of clear functionality
                    // end otp verification
                  }
                } else {
                  this.err_msg = res.msg;
                }
              })
              .finally(() => {
                // stuffs happens here
              });
          }
        }
      });
    }
  },
  created() {
    this.userAccount = 'vip_sonko';
    if (this.userAccount == "expert") {
      this.accountType = "Expert";
      this.toolbarColor = "blue darken-1";
    } else if (this.userAccount == "sonko") {
      this.accountType = "Sonko";
      this.toolbarColor = "green darken-1";
    } else if (this.userAccount == "vip_sonko") {
      this.accountType = "VIP Sonko";
      this.toolbarColor = "green darken-1";
    }
  }
};
</script>

<style>
.logo-img {
  cursor: pointer;
}
/*@media (max-width: 768px) {
  .placeholder-div .v-label {
    font-size: 11px;
  }
}*/
@media (max-width: 420px) {
  .placeholder-div .v-label {
    font-size: 10px;
  }
  .display-small {
    font-size: 12px;
  }
}
@media (min-width: 420px) and (max-width: 572px) {
  .display-small {
    font-size: 14px;
  }
}
</style>
